<!-- eslint-disable -->
<template>
  <div>
    
    <div class="p2_grid_container G_box">
      <div class="p2_logo_container">
        <img @click.prevent="gotoHome" class="p2_logo" src="/dynamic/images/placeholder.png">
        <div class="p2_company_name"></div>
        
      </div>
      <div class="p2_header_content">
        <div class="p2_header_email" v-if="userInfo['authenticated'] === true">{{userInfo['contactEmail']}}</div>
          <div class="p2_notifications_container">
            <div v-if="accountNotificationsCount>1"
              @click="gotoAccountNotifications"
              >
            {{accountNotificationsCount}} account notifications, click here to view.
            </div>
            <div v-if="accountNotificationsCount === 1"
              @click="gotoAccountNotifications"
            >
              {{accountNotificationsCount}} account notification, click here to view.
            </div>
          </div>
        <button class="p2_logout_button" v-if="userInfo['isGuest'] === false &&
        userInfo['authenticated'] === true 
        " @click='logout()'>Logout</button>
        
        <button class="p2_login_button" v-if="userInfo['isGuest'] === true" @click='login()'>Login</button> 
        <div
          id="p2_ID_header_qr_code_container"
          @click="toggleQrCodePopup"
          class="p2_header_qr_code_container"
          >
          <button class="p2_header_qr_code_button">QR</button>
        </div>       
      </div>
      <!--<start> QR code of the current page -->
      <div
        id="p2_ID_active_URL_qr_code_container"
        @click="toggleQrCodePopup"
        class="p2_active_url_qr_code_container"
        >
        <div id="p2_ID_svg_image_container"></div>
        <button class="p2_header_qr_code_container"><b>QR</b></button>
      </div>
      <div
        id="p2_ID_active_URL_qr_code_container_popup"
        @click="toggleQrCodePopup"
        :class="{G_hidden_element: qrCodePopupActive === false, p2_active_url_qr_code_container_popup: qrCodePopupActive === true}"
        >
      </div>
      <!--</end> QR code of the current page -->

      
      <div :class="{ p2_active_tab: activeSubpage === 'p2s1' }" 
        class="p2_tab p2_tab1" 
        @click.prevent="selectp2s1"
        >
      </div>
      <div :class="{ p2_active_tab: activeSubpage === 'p2s2' }"
        class="p2_tab p2_tab2" 
        @click.prevent="selectSubpage('p2s2')">
      </div>
      <div :class="{ p2_active_tab: activeSubpage === 'p2s3' }"
        class="p2_tab p2_tab3" 
        @click.prevent="selectSubpage('p2s3')">
      </div>
      <div v-if="isInitiailized === true" class="p2_panel">
        <my-organizations
          v-if="'p2s1' in subPageSubItemLists"
          :class="{ p2_inactive_panel: activeSubpage !== 'p2s1'}"
          :subItemIndex="1"
          :subItemsList="subItemsList"
          :parentParams="params"
          @event-sub-items-change="eventSubItemsChange"
          @event-parameter-change="eventParamsChange"
          @event-sub-items-loaded="eventSubItemsLoaded"
          @event-set-children-visible="eventSetChildrenVisible"
        >
        </my-organizations>
        <notifications
          v-if="'p2s2' in subPageSubItemLists"
          :class="{ p2_inactive_panel: activeSubpage !== 'p2s2'}"
          :subItemIndex="1"
          :subItemsList="subItemsList"
          :parentParams="params"
          @event-sub-items-change="eventSubItemsChange"
          @event-parameter-change="eventParamsChange"
          @event-sub-items-loaded="eventSubItemsLoaded"
          @event-set-children-visible="eventSetChildrenVisible"
        ></notifications>
        <account-settings 
          v-if="'p2s3' in subPageSubItemLists"
          :class="{ p2_inactive_panel: activeSubpage !== 'p2s3'}"
          :subItemIndex="1"
          :subItemsList="subItemsList"
          :parentParams="params"
          @event-sub-items-change="eventSubItemsChange"
          @event-parameter-change="eventParamsChange"
          @event-sub-items-loaded="eventSubItemsLoaded"
          @event-set-children-visible="eventSetChildrenVisible"
        ></account-settings>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import MyOrganizations from "./p2s1MyOrganizations/p2s1MyOrganizations";
import Notifications from "./p2s2notifications/p2s2Notifications";
import AccountSettings from "./p2s3accountSettings/p2s3AccountSettings";
import AWN from "awesome-notifications"
import sendAccountNotificationResponse from '../../watchdog_includes/legacy_calls/p2s1t12_SendAccountNotificationRepsonse'
import {bi10PageTemplate} from '../../watchdog_includes/base_i10_UI_mixins'
import { userInfo } from 'os';
import QrCodeGenerator from "qrcode-generator-es6"

export default {
  name: "p2Dashboard",
  components: {
    MyOrganizations,
    Notifications,
    AccountSettings
  },
  mixins: [bi10PageTemplate],
  data: function() {
    return {
      baseUrl: "/dashboard",
      userInfo: {},
      accountNotifications: {},
      accountNotificationsPopupShown: false,
      accountNotificationsCount:0,
      defaultSubpage:'p2s1',
      qrCodePopupActive: false
    };
  },
  methods: {
    gotoHome: function() {
      window.vue_instance.$router.push('/');
    },
    gotoAccountNotifications() {
        this.selectSubpage('p2s3')
        var new_sub_items_list = ['p2s3','default'];
        this.eventSubItemsChange(new_sub_items_list);
        
    },
    selectp2s1() {
      if(this.activeSubpage !== 'p2s1') {
        this.selectSubpage('p2s1')
      } else {
        this.selectSubpage('p2s1')
        var new_sub_items_list = ['p2s1','default','close_modal'];
        this.eventSubItemsChange(new_sub_items_list);
        
      }
    },
    toggleQrCodePopup() {
      this.qrCodePopupActive = !this.qrCodePopupActive;
    },

    waitWatchdogReadyCallback() {
      this.accountNotifications = window.G_watchdog_data.IV_account_notificaitons;
      this.userInfo = window.vue_instance.$root.$data.userInfo;
    }

  },
  watch: {
    accountNotifications: {
      handler: function() {
        const CI = this
        let notifications_count = 0
        for(let key in CI.accountNotifications) {
          notifications_count +=1

          ///// Organization invites logic
          if (CI.accountNotificationsPopupShown === false && CI.accountNotifications[key]['notice_type'] === 'org_invite') {
            CI.accountNotificationsPopupShown = true
            const popup_notice_id = CI.accountNotifications[key]['notice_id']

            // If the user visits via easy sign_up link
            if (window.G_firebase_auth.IV_automatic_user_creation_flag === true &&
                window.G_firebase_auth.IV_easy_sign_up_org_uid === CI.accountNotifications[key]["org_id"]) {
              // Auto-confirm the invite that matches the invite's organization uid
              sendAccountNotificationResponse(window.G_watchdog_data.IV_user_info['contact_email'], popup_notice_id, "accept")
              // and reset the flag so other notifications process normally.
              window.G_firebase_auth.IV_automatic_user_creation_flag = false
              window.G_firebase_auth.IV_easy_sign_up_org_uid = null
            } else {
              // Else ask user to accept/reject the invitation
              const popup_options = { labels: { confirm: "Organization Invitation" }, modal: { okLabel: "Accept", cancelLabel: "Decline" }, position: "center" }
              let popup = new AWN(popup_options)
              popup.confirm(CI.accountNotifications[key]['description'],
                function() {
                  sendAccountNotificationResponse(window.G_watchdog_data.IV_user_info['contact_email'], popup_notice_id, "accept")
                }.bind(CI),
                function() {
                  sendAccountNotificationResponse(window.G_watchdog_data.IV_user_info['contact_email'], popup_notice_id, "decline")
                }.bind(CI)
              )
            }
          }
          /////</end> Organization invites logic
        }
        // Show total count on the header
        CI.accountNotificationsCount = notifications_count
      },
      deep:true
    },
    subItemsList: {
      handler: function() {
        var qr_code_generator = new QrCodeGenerator(0,'L');
        qr_code_generator.addData(window.location.href);
        qr_code_generator.make();
        
        let qr_image_element = document.getElementById("p2_ID_svg_image_container");
        qr_image_element.innerHTML = qr_code_generator.createSvgTag({});

        var qr_image_element_popup = document.getElementById("p2_ID_active_URL_qr_code_container_popup");        
        qr_image_element_popup.innerHTML = qr_code_generator.createSvgTag({});
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/p2Dashboard/p2Dashboard.vue